import { createUseStyles } from "react-jss";
import { ITheme } from "../../../store/slices/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  root: {
    backgroundColor: theme.colors.background3,
    padding: theme.spacing.space16,
    borderRadius: theme.radius.medium,
  },
  content: {
    display: "flex",
    gap: theme.spacing.space8,
  },
  source: {
    marginBottom: theme.spacing.space4,
  },
  newsImg: {
    height: 88,
    width: 88,
    borderRadius: theme.radius.medium,
  },
  bottomTime: {
    display: "flex",
    alignItems: "center",
    marginTop: theme.spacing.space8,
  },
  time: {
    color: theme.colors.TextSilver,
    paddingLeft: theme.spacing.space20,
    margin: 0,
  },
}));
